import * as types from '../mutation-types'

// state
export const state = {
    enrolments: [],
    loading: true,
};

// mutations
export const mutations = {
    [types.SET_ENROLMENTS](state, {enrolments, clear}) {
        state.enrolments = enrolments;

        if(clear) {
            return state.loading = true;
        }
        state.loading = false;
    },
};

// actions
export const actions = {
    async retrieveEnrolments({commit, dispatch}, {trajectory_project_id, trajectory_id, status}) {
        let requestData = {
            trajectory_project: trajectory_project_id,
            trajectory: trajectory_id,
        };

        if (status) {
            requestData.status = status;
        }

        const {data} = await window.axios.get(route('trajectory-projects.trajectories.trajectory-enrolments.index', requestData));

        commit(types.SET_ENROLMENTS, { enrolments: data, clear: false })
    },

    clearEnrolments({commit, dispatch}) {
        commit(types.SET_ENROLMENTS, { enrolments: [], clear: true });
    }
};

// getters
export const getters = {
    enrolments: state => state.enrolments,
    isLoading: state => state.loading,
};